import React, { useState } from 'react'
import {
  Div, H4, Input,
} from 'konsys-ui'
import { theme } from '../../../../../styles/_variables'
import {
  ButtonEdit, InputNumber,
} from './styled'


const { color } = theme

const FoilingCostMinimumInput = ({
  data,
  onInputChange,
  action,
}) => {
  const [actionState, setActionState] = useState(action)
  const [costMinimum, setCostMinimum] = useState(data.costMinimum || 0)
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='flex-start' alignItems='baseline' moreStyle={{ columnGap: '12px' }}>
        <H4 bold color={color.primaryColor} margin='16px 0px 32px 0px'>ต้นทุนขั้นต่ำ</H4>
        {
          actionState === 'create' ? <>
          <InputNumber
            value={data.costMinimum}
            min={0}
            max={9999}
            step="1"
            type='number'
            onChange={(e) => {
              onInputChange({ ...data, costMinimum: Math.round(e * 100) / 100 })
            }}
            onKeyPress={(e) => {
              if (e.charCode !== 46 && !(e.charCode >= 48 && e.charCode <= 57)) {
                e.preventDefault()
              }
            }}
            style={{ width: '20%' }}
          />
          <H4 bold color={color.primaryColor} margin='16px 0px 32px 0px'>บาท</H4>
          </> : actionState === 'detail' ? <>
            <H4 bold color={color.textColor} margin='16px 0px 32px 0px'>{data.costMinimum} บาท</H4>
            <ButtonEdit
              text='แก้ไข'
              icon='fa fa-pencil'
              inverse
              onClick={() => setActionState('edit')}
            />
          </> : actionState === 'edit' ? <>
            <InputNumber
              value={costMinimum}
              min={0}
              max={9999}
              step="1"
              type='number'
              onChange={(e) => {
                setCostMinimum(Math.round(e * 100) / 100)
              }}
              style={{ width: '20%' }}
            />
            <H4 bold color={color.primaryColor} margin='16px 0px 32px 0px'>บาท</H4>
            <ButtonEdit
              text='ยกเลิก'
              onClick={() => {
                setCostMinimum(data.costMinimum)
                setActionState('detail')
              }}
            />
            <ButtonEdit
              text='ยืนยัน'
              inverse
              onClick={() => {
                onInputChange({ ...data, costMinimum: Math.round(costMinimum * 100) / 100 })
                setActionState('detail')
              }}
            />
          </> : null
        }
      </Div>
    </Div>
  )
}

export default FoilingCostMinimumInput
